import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

export const CommonCancellationsCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Cancellazioni',
    path: '/cancellazioni',
  },
];

export const ResearchNotificationsCancellationsCrumbs = [
  ...CommonCancellationsCrumbs,
  {
    name: 'Ricerca Registrazioni SC - Anagrafe',
    path: '/cancellazioni/notifiche-da-stato-civile',
  },
];

export const DetailNotificationsCancellationsCrumbs = [
  ...ResearchNotificationsCancellationsCrumbs,
  {
    name: 'Dettaglio Ricerca Registrazioni SC - Anagrafe',
    path: '/cancellazioni/notifiche-da-stato-civile/visualizza/:id/:idNotifica',
  },
];

export const EditNotificationsCancellationsCrumbs = (goBackUrl: string): Array<BreadcrumbItem> => {
  return [
    ...ResearchNotificationsCancellationsCrumbs,
    {
      name: 'Modifica Ricerca Registrazioni SC - Anagrafe',
      path: goBackUrl,
    },
  ];
};

export const BirthNotificationsNonResidentCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Registrazione Nascita Non Residenti',
      path: `${goBackUrl}/nascita/non-residenti`,
    },
  ];
};

export const CivilUnionNotificationsResidentCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/unione-civile/residenti`,
    },
  ];
};

export const CivilUnionDetailNotificationsResidentCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...CivilUnionNotificationsResidentCancellationsCrumbs(goBackUrl),
    {
      name: 'Registrazione Unione Civile',
      path: `${goBackUrl}/unione-civile/residenti/registrazione`,
    },
  ];
};

export const CivilUnionNotificationsNonResidentCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/unione-civile/non-residenti`,
    },
  ];
};

export const CivilUnionDetailNotificationsNonResidentCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...CivilUnionNotificationsNonResidentCancellationsCrumbs(goBackUrl),
    {
      name: 'Registrazione Unione Civile Non Residenti',
      path: `${goBackUrl}/unione-civile/non-residenti/registrazione`,
    },
  ];
};

export const MarriageNotificationsResidentCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/matrimonio/residenti`,
    },
  ];
};

export const MarriageDetailNotificationsResidentCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...MarriageNotificationsResidentCancellationsCrumbs(goBackUrl),
    {
      name: 'Registrazione Matrimonio',
      path: `${goBackUrl}/matrimonio/residenti/registrazione`,
    },
  ];
};

export const MarriageNotificationsNonResidentCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/matrimonio/non-residenti`,
    },
  ];
};

export const MarriageDetailNotificationsNonResidentCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...MarriageNotificationsNonResidentCancellationsCrumbs(goBackUrl),
    {
      name: 'Registrazione Matrimonio Non Residenti',
      path: `${goBackUrl}/matrimonio/non-residenti/registrazione`,
    },
  ];
};

export const DeathNotificationsResidentCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/morte/residenti`,
    },
  ];
};

export const DeathCancellationNotificationsResidentCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...DeathNotificationsResidentCancellationsCrumbs(goBackUrl),
    {
      name: 'Cancellazione',
      path: `${goBackUrl}/morte/residenti/cancellazione`,
    },
  ];
};

export const DeathNotificationsNonResidentCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/morte/non-residenti`,
    },
  ];
};

export const DeathCancellationNotificationsNonResidentCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...DeathNotificationsNonResidentCancellationsCrumbs(goBackUrl),
    {
      name: 'Cancellazione',
      path: `${goBackUrl}/morte/non-residenti/cancellazione`,
    },
  ];
};

export const CitizenshipNotificationsCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/cittadinanza/ricerca`,
    },
  ];
};

export const CitizenshipRegistrationNotificationsCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...CitizenshipNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Registrazione',
      path: `${goBackUrl}/cittadinanza/ricerca/registrazione`,
    },
  ];
};

export const FamilyNotificationsCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia`,
    },
  ];
};

export const FamilyOtherNotificationsCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia/altra`,
    },
  ];
};

export const FamilyMotherNotificationsCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia/madre`,
    },
  ];
};

export const FamilyFatherNotificationsCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia/padre`,
    },
  ];
};

export const FamilyDetailNotificationsCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...FamilyNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: '/cancellazioni/notifiche-da-stato-civile/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const FamilyOtherDetailNotificationsCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...FamilyOtherNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: '/cancellazioni/notifiche-da-stato-civile/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const FamilyMotherDetailNotificationsCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...FamilyMotherNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: '/cancellazioni/notifiche-da-stato-civile/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const FamilyFatherDetailNotificationsCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...FamilyFatherNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: '/cancellazioni/notifiche-da-stato-civile/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const CohabitationNotificationsCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Convivenza',
      path: `${goBackUrl}/convivenza`,
    },
  ];
};

export const CohabitationDetailNotificationsCancellationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...CohabitationNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Nascita Convivenza',
      path: '/cancellazioni/notifiche-da-stato-civile/modifica/:id/:idNotifica/convivenza/nascita',
    },
  ];
};
